import { useResponsive } from 'hooks/useResponsive'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const useTrackHeight = () => {
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  return isMobile ? 60 : 80
}
